import { isMobile, isAuthor } from "../../../js/utils";

(() => {
  const BRHGalleryRooms = () => {
    const selectors = {
      component: "brh-gallery-rooms",
      container: "brh-gallery-rooms__container",
      room: "brh-gallery-room",
    };

    const init = () => {
      const parentElement = Array.from(document.getElementsByClassName(selectors.component));
      if (parentElement) {
        parentElement.forEach((element) => {
          if (element && !isAuthor() && !isMobile()) {
            // fadeIn({classElement:".js-gallery-rooms", duration:3});
            const roomElements = element.querySelectorAll("." + selectors.container + " ." + selectors.room);
            if (roomElements?.length > 2) {
              const swiperElement = element.querySelector("." + selectors.container);
              swiperElement.classList.add("slider");

              const swiperWrapper = swiperElement.querySelector(".brh-gallery-rooms__swiper-wrapper");
              roomElements.forEach((room) => {
                room.classList.add("swiper-slide");
                swiperWrapper.insertAdjacentElement("beforeend", room);
              });

              element.querySelector(".brh-gallery-rooms__swiper-navigations")?.classList.remove("hidden");

              new window.Swiper(swiperElement, {
                slidesPerView: 2,
                freeMode: false,
                navigation: {
                  nextEl: ".brh-gallery-rooms__swiper-button.swiper-button-next",
                  prevEl: ".brh-gallery-rooms__swiper-button.swiper-button-prev",
                },
              });
            }
          }
        });
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHGalleryRooms);
})();
